<div class="container">

  <div class="row">
    <div class="col-md-12">
      <h2>Results View</h2>
      <p>Design how data should be shown in the main search dashboard, individually, and across your team.</p>
    </div>
  </div>

  @if (!isLoadingSignal().isLoadingInitialData) {
  <div class="row">
    <div class="col-md-12">
      <ul class="nav nav-tabs small-margin-top" role="tablist" id="nav-items-holder">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" data-target="#user-views-tab" role="tab"
            (click)="activateUserSettings()">
            Your Views
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" data-target="#organisation-views-tab" role="tab"
            (click)="activateOrganisationSettings()">
            Organisation/Team Views
          </a>
        </li>
      </ul>
    </div>
  </div>
  }

  @if (isLoadingSignal().isLoadingInitialData) {
  <div class="row mt-3 medium-margin-bottom">
    <div class="col-md-12 d-flex justify-content-center align-items-center" style="min-height: 400px;">
      <zint-loader size="large"></zint-loader>
    </div>
  </div>
  } @else {
  <div class="tab-content">


    <div class="tab-pane active editor-tab-pane" role="tabpanel" id="user-views-tab">
    <div class="editor-scroll-wrapper">
        <div class="view-management-section mt-5">
            <div class="view-management-group" style="flex-grow: 1.5;">
                <label>Add a new view:</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="My New View" name="newResultsFormatName"
                    [(ngModel)]="newResultsFormatName"
                    [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                  <button class="btn" type="button" (click)="createNewResultsFormat()"
                    [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                    @if (isLoadingSignal().isUpdatingAResultsFormat) {
                      <i class="fal fa-spinner fa-spin"></i>
                    } @else {
                      <i class="fal fa-plus-circle"></i>
                    }
                  </button>
                </div>
              </div>

            <div class="view-management-group mb-5 mt-3" style="flex-grow: 1;">
              <label>Choose your default view:</label>
              <select class="zint-select" name="defaultFormat" (change)="changeDefaultFormat($event.target.value)">
                <option value="">-- Select Default --</option>
                @for (setting of individualResultsFormatSettings; track setting.id) {
                <option [value]="setting.id" [attr.selected]="setting.is_default === true ? 'selected' : null">
                  {{setting.name}}
                </option>
                }
                @for (setting of organisationResultsFormatSettings; track setting.id) {
                <option [value]="setting.id" [attr.selected]="setting.is_default === true ? 'selected' : null">
                  {{setting.name}}
                </option>
                }
              </select>
            </div>

            <hr>



            <div class="view-management-row">
              <div class="view-management-group" style="flex-grow: 1.5;">
                <label>Select a view to edit:</label>
                @if (individualResultsFormatSettings?.length) {
                  <select [(ngModel)]="resultsFormatBeingEdited" class="zint-select" name="userResultsFormatBeingEdited"
                    (change)="userResultsFormatEditingChanged();">
                    @for (setting of individualResultsFormatSettings; track setting.id) {
                    <option [ngValue]="setting">{{setting.name}}</option>
                    }
                  </select>
                } @else {
                  <select class="zint-select" disabled>
                    <option>Create a new view to begin</option>
                  </select>
                }
              </div>
            </div>

            @if (resultsFormatBeingEdited) {
              <div class="view-management-row mt-3">
                <div class="view-management-group" style="flex-grow: 1.5;">
                  <label>Edit Name:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" name="userNameBeingChanged" [(ngModel)]="nameBeingChanged"
                      [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                    <button class="btn" type="button"
                      (click)="saveResultsFormatName(resultsFormatBeingEdited)"
                      [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                      @if (isLoadingSignal().isUpdatingAResultsFormat) {
                        <i class="fal fa-spinner fa-spin"></i>
                      } @else {
                        <i class="fal fa-save"></i>
                      }
                    </button>
                  </div>
                </div>
                <div class="view-management-group" style="flex: 0 0 auto;">
                  <label>&nbsp;</label>
                  <div class="button-group-row" style="display: flex; gap: 0.5rem;">
                    <button class="rounded-btn-base rounded-btn-red-outline btn-delete" (click)="deleteFormat()">
                      <i class="fal fa-trash"></i> Delete
                    </button>
                    <button type="button" class="rounded-btn-base rounded-btn-dark-cta btn-p-md" (click)="saveChanges()"
                      [disabled]="isLoadingSignal().isUpdatingAResultsFormat"
                      style="padding-top: 0.65rem; padding-bottom: 0.65rem;">
                      @if (isLoadingSignal().isUpdatingAResultsFormat) {
                      <zint-loader size="xxSmall" [isInline]="true" dotColor="white"></zint-loader>
                      } @else {
                      <span>Save</span>
                      }
                    </button>
                  </div>
                </div>
              </div>
            }
        </div>

          @if (resultsFormatBeingEdited) {
          <div class="column-editor-container">
            <div class="editor-column column-all">
              <div class="column-header">
                <h4 class="text-zint-dark-blue">Column Choices</h4>
              </div>
              <div class="search-input">
                <i class="fal fa-search"></i>
                <input type="text" class="rounded-input-base" placeholder="Search Columns..."
                  [(ngModel)]="columnSearchTerm" name="userColumnSearch">
              </div>
              <div class="column-groups-container scrollbar-show">
                @for (group of columnGroups; track group.name) {
                <details class="column-group" [open]="group.open">
                  <summary class="column-group-header">
                    <span class="text-bold-600">{{ group.name }}</span>
                    <span class="column-count text-grey-500">
                      ({{ getSelectedCountForGroup(group) }} of {{ group.items.length }})
                    </span>
                  </summary>
                  <div class="group-items">
                    <div class="group-item select-all-item">
                      <input type="checkbox" [id]="'user-' + group.name + '-select-all'"
                        [checked]="isGroupAllSelected(group)" (change)="toggleSelectSection($event, group)">
                      <label [for]="'user-' + group.name + '-select-all'">Select all in this section</label>
                    </div>
                    @for (item of getFilteredList(group.items, columnSearchTerm); track $index) {
                    <div class="group-item">
                      <input type="checkbox" [id]="'user-' + getHeaderId(item, group.name)"
                        [checked]="isHeaderSelected(item)" (change)="onCheckboxChange($event, item)">
                      <label [for]="'user-' + getHeaderId(item, group.name)">{{ getHeaderName(item) }}</label>
                    </div>
                    }
                  </div>
                </details>
                }
              </div>
            </div>

            <div class="editor-column column-selected">
              <div class="column-header">
                <h4 class="text-zint-dark-blue">Selected Columns In View</h4>
                <span class="column-count text-grey-500">
                  ({{ resultsFormatBeingEdited.format.length }} of {{ totalColumnCount }})
                </span>
              </div>
              <div cdkDropList (cdkDropListDropped)="dragSort($event)" class="selected-list-container scrollbar-show">
                @for (item of resultsFormatBeingEdited.format; track $index) {
                <div class="selected-item" cdkDrag>
                  <i class="fal fa-grip-lines cursor-move" cdkDragHandle></i>
                  <span class="selected-item-name">{{ getHeaderName(item) }}</span>
                  <button class="remove-btn" (click)="removeHeaderFromSelection(item)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
                } @empty {
                <div class="selected-item-empty text-grey-600">
                  <span>Select columns from the left to add them here.</span>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
    </div>

    <div class="tab-pane editor-tab-pane" role="tabpanel" id="organisation-views-tab">

      <div class="editor-scroll-wrapper">
        <div class="view-management-section mt-5">
            @if (inputParams.isSuperUser) {
              <div class="view-management-group" style="flex-grow: 1.5;">
                <label>Add a new view:</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="My Team's New View" name="newOrgResultsFormatName"
                    [(ngModel)]="newResultsFormatName"
                    [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                  <button class="btn" type="button" (click)="createNewOrganisationResultsFormat()"
                    [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                    @if (isLoadingSignal().isUpdatingAResultsFormat) {
                      <i class="fal fa-spinner fa-spin"></i>
                    } @else {
                      <i class="fal fa-plus-circle"></i>
                    }
                  </button>
                </div>
              </div>

              <div class="view-management-group mb-5 mt-3" style="flex-grow: 1;">
                <label>Choose your default view:</label>
                <select class="zint-select" name="defaultOrgFormat" (change)="changeDefaultOrganisationFormat($event.target.value)">
                  <option value="">-- Select Default --</option>
                  @for (setting of organisationResultsFormatSettings; track setting.id) {
                  <option [value]="setting.id" [attr.selected]="setting.is_default">{{setting.name}}</option>
                  }
                </select>
              </div>

              <hr>

              <div class="view-management-row">
                <div class="view-management-group" style="flex-grow: 1.5;">
                  <label>Select a view to edit:</label>
                  @if (organisationResultsFormatSettings?.length) {
                    <select [(ngModel)]="resultsFormatBeingEdited" class="zint-select" name="orgResultsFormatBeingEdited"
                      (change)="userResultsFormatEditingChanged();">
                      @for (setting of organisationResultsFormatSettings; track setting.id) {
                      <option [ngValue]="setting">{{setting.name}}</option>
                      }
                    </select>
                  } @else {
                    <select class="zint-select" disabled>
                      <option>Create a new view to begin</option>
                    </select>
                  }
                </div>
              </div>

              @if (resultsFormatBeingEdited) {
                <div class="view-management-row mt-3">
                  <div class="view-management-group" style="flex-grow: 1.5;">
                    <label>Edit Name:</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="orgNameBeingChanged" [(ngModel)]="nameBeingChanged"
                        [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                      <button class="btn" type="button"
                        (click)="saveOrganisationResultsFormatName(resultsFormatBeingEdited)"
                        [attr.disabled]="isLoadingSignal().isUpdatingAResultsFormat ? 'disabled': null">
                        @if (isLoadingSignal().isUpdatingAResultsFormat) {
                          <i class="fal fa-spinner fa-spin"></i>
                        } @else {
                          <i class="fal fa-save"></i>
                        }
                      </button>
                    </div>
                  </div>
                  <div class="view-management-group" style="flex: 0 0 auto;">
                    <label>&nbsp;</label>
                    <div class="button-group-row" style="display: flex; gap: 0.5rem;">
                      <button class="rounded-btn-base rounded-btn-red-outline btn-delete" (click)="deleteOrganisationFormat()">
                        <i class="fal fa-trash"></i> Delete
                      </button>
                      @if (inputParams.isSuperUser) {
                        <button type="button" class="rounded-btn-base rounded-btn-dark-cta btn-p-md" (click)="saveChanges()"
                          [disabled]="isLoadingSignal().isUpdatingAResultsFormat"
                          style="padding-top: 0.65rem; padding-bottom: 0.65rem;">
                          @if (isLoadingSignal().isUpdatingAResultsFormat) {
                          <zint-loader size="xxSmall" [isInline]="true" dotColor="white"></zint-loader>
                          } @else {
                          <span>Save</span>
                          }
                        </button>
                      }
                    </div>
                  </div>
                </div>
              }
            } @else {
              <div class="view-management-row">
                <div class="view-management-group" style="flex-grow: 1.5;">
                  <label>Your Organisation Views:</label>
                  @if (organisationResultsFormatSettings?.length) {
                    <select [(ngModel)]="resultsFormatBeingEdited" class="zint-select" name="orgResultsFormatBeingEdited_readonly"
                      (change)="userResultsFormatEditingChanged();">
                      @for (setting of organisationResultsFormatSettings; track setting.id) {
                      <option [ngValue]="setting">{{setting.name}}</option>
                      }
                    </select>
                  } @else {
                    <p class="text-grey-600 mt-2">Your organisation has not created any shared views yet.</p>
                  }
                </div>
              </div>
            }
        </div>


      @if (resultsFormatBeingEdited) {
      <div class="column-editor-container">
        @if (inputParams.isSuperUser) {
        <div class="editor-column column-all">
          <div class="column-header">
            <h4 class="text-zint-dark-blue">Column Choices</h4>
          </div>
          <div class="search-input">
            <i class="fal fa-search"></i>
            <input type="text" class="rounded-input-base" placeholder="Search Columns..."
              [(ngModel)]="columnSearchTerm" name="orgColumnSearch">
          </div>
          <div class="column-groups-container scrollbar-show">
            @for (group of columnGroups; track group.name) {
            <details class="column-group" [open]="group.open">
              <summary class="column-group-header">
                <span class="text-bold-600">{{ group.name }}</span>
                <span class="column-count text-grey-500">
                  ({{ getSelectedCountForGroup(group) }} of {{ group.items.length }})
                </span>
              </summary>
              <div class="group-items">
                <div class="group-item select-all-item">
                  <input type="checkbox" [id]="'org-' + group.name + '-select-all'"
                    [checked]="isGroupAllSelected(group)" (change)="toggleSelectSection($event, group)">
                  <label [for]="'org-' + group.name + '-select-all'">Select all in this section</label>
                </div>
                @for (item of getFilteredList(group.items, columnSearchTerm); track $index) {
                <div class="group-item">
                  <input type="checkbox" [id]="'org-' + getHeaderId(item, group.name)"
                    [checked]="isHeaderSelected(item)" (change)="onCheckboxChange($event, item)">
                  <label [for]="'org-' + getHeaderId(item, group.name)">{{ getHeaderName(item) }}</label>
                </div>
                }
              </div>
            </details>
            }
          </div>
        </div>
        }

        <div class="editor-column column-selected" [class.column-full-width]="!inputParams.isSuperUser">
          <div class="column-header">
            <h4 class="text-zint-dark-blue">Selected Columns In View</h4>
            <span class="column-count text-grey-500">
              ({{ resultsFormatBeingEdited.format.length }} of {{ totalColumnCount }})
            </span>
          </div>
          <div cdkDropList (cdkDropListDropped)="dragSort($event)" class="selected-list-container scrollbar-show"
            [cdkDropListDisabled]="!inputParams.isSuperUser">

            @for (item of resultsFormatBeingEdited.format; track $index) {
            <div class="selected-item" [cdkDragDisabled]="!inputParams.isSuperUser" cdkDrag>

              @if (inputParams.isSuperUser) {
              <i class="fal fa-grip-lines cursor-move" cdkDragHandle></i>
              }

              <span class="selected-item-name">{{ getHeaderName(item) }}</span>

              @if (inputParams.isSuperUser) {
              <button class="remove-btn" (click)="removeHeaderFromSelection(item)">
                <i class="fal fa-times"></i>
              </button>
              }
            </div>
            } @empty {
            <div class="selected-item-empty text-grey-600">
              <span>
                @if (inputParams.isSuperUser) {
                Select columns from the left to add them here.
                } @else {
                This view is read-only.
                }
              </span>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    </div>

  </div>
  }
</div>
